import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
  selector: 'app-navbar-barcode',
  templateUrl: './navbar-barcode.component.html'
})
export class NavbarBarcodeComponent implements OnInit {
  @ViewChild('scanner') scanner: ZXingScannerComponent;
  
  public hasCamerasFound = false;
  public camerasFound: any[];
  public device: any;
  public modal: any;

  // Removido o Camera e AndroidPermissions do construtor
  constructor(
    private modalService: NgbModal, 
    private router: Router
  ) {}

  modalOpenVC(modalVC) {
    this.modal = this.modalService.open(modalVC, {
      centered: true
    });
  }

  onCodeResult(resultString: string): void {
    // Primeiro vai ao catálogo para garantir o correto funcionamento se já estiver na loja
    this.router.navigate(['/apps/e-commerce/catalogs']).then(() => {
      this.router.navigate(['/apps/e-commerce/shop/'], { queryParams: { q: resultString } }).then(() => {
        this.modal.close();
      });
    });
  }

  camerasNotFoundHandler(camerasFound): void {
    this.hasCamerasFound = false;
    this.camerasFound = null;
  }

  camerasFoundHandler(camerasFound): void {
    this.hasCamerasFound = true;
    this.camerasFound = camerasFound;
    this.device = this.camerasFound[0];
  }

  changeCamera() {
    if (this.device && this.camerasFound) {
      const currentDevice = this.device;
      const nextDevice = this.camerasFound.find(device => device.deviceId !== currentDevice.deviceId);
      if (nextDevice) {
        this.device = nextDevice;
      }
    }
  }

  ngOnInit(): void {
    // Na Web/PWA não precisamos de pedir permissão manualmente no arranque.
    // O @zxing/ngx-scanner pede permissão ao browser assim que o modal abre e o componente renderiza.
  }
}